import React from 'react';
import { getISODay } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import { hourStatusToLabelInfoMap } from './StatusLabel.constants';
import { getAllHourStatus, getHighestPriorityHourStatus } from './StatusLabel.utils';
import { HourOfOperationPropType } from '../../../../services/proptypes';
import { isServerSideRendering } from '../../../../utils/gatsby';
import { EnhancedLabelsPropType } from '../../HoursOfOperation.PropTypes';
var defaultProps = {
  timezone: null,
  enhancedLabels: {}
};

/**
 * Returns null if it's not today or no timezone is set, else Open or Closed.
 * Inspired on https://stackoverflow.com/a/59492313
 *
 * Assumes all hours[i].day are the same
 */
export default function StatusLabel(_ref) {
  var hours = _ref.hours,
    timezone = _ref.timezone,
    enhancedLabels = _ref.enhancedLabels;
  if (isServerSideRendering()) {
    return null;
  }
  // Can't be totally sure without a timezone,
  // so don't do this if we don't have one.
  if (!timezone || timezone === 'UTC' || hours.length === 0) {
    return null;
  }

  // If weekday isn't today.
  var now = utcToZonedTime(new Date(), timezone);
  var weekDayIso = getISODay(now);
  if (weekDayIso !== hours[0].day) {
    return null;
  }
  var allHourStatus = getAllHourStatus(hours, now, timezone);
  var bestStatus = getHighestPriorityHourStatus(allHourStatus);
  var labelInfo = _get(hourStatusToLabelInfoMap, bestStatus, null);
  if (_isNil(labelInfo)) {
    return null;
  }
  var defaultLabel = labelInfo.defaultLabel,
    alternateLabelKey = labelInfo.alternateLabelKey,
    className = labelInfo.className;
  var label = _get(enhancedLabels, alternateLabelKey, defaultLabel);
  return /*#__PURE__*/React.createElement("span", {
    className: className,
    style: {
      fontWeight: 'bold'
    }
  }, label);
}
StatusLabel.defaultProps = defaultProps;